import React from 'react'
import DropDownList from './base-components/DropDownList'

const months = [
      {
        text: '01 - January',
        value: '01'
      },
      {
        text: '02 - February',
        value: '02'
      },
      {
        text: '03 - March',
        value: '03'
      },
      {
        text: '04 - April',
        value: '04'
      },
      {
        text: '05 - May',
        value: '05'
      }
      ,{
        text: '06 - June',
        value: '06'
      }
      ,{
        text: '07 - July',
        value: '07'
      }
      ,{
        text: '08 - August',
        value: '08'
      },
      {
        text: '09 - September',
        value: '09'
      },
      {
        text: '10 - October',
        value: '10'
      },
      {
        text: '11 - November',
        value: '11'
      },
      {
        text: '12 - December',
        value: '12'
      }
    ];


interface Props {
    label:string;
    name:string;
    selected:any;
    getValue:(s:string)=>void;
}
export default class MonthPicker extends React.Component<Props> {
  render() {
    return (
      <div>
        <DropDownList
          label={this.props.label}
          name={this.props.name}
          dataList={months}
          className={'ui-test-input-required'}
          required
          hint="MM"
          valueName={"value"}
          valueText={"text"}
          value={this.props.selected}
          onChange={(v:any)=>{this.props.getValue(v as string)}}
        />
      </div>
    )
  }

}